import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "m3 15 4-8 4 8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M4 13h6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M15 11h4.5a2 2 0 0 1 0 4H15V7h4a2 2 0 0 1 0 4",
            stroke: `${color}`
          }
        )
      ]
    }
  );
};
Icon.displayName = "CaseUpper";
const CaseUpper = memo(themed(Icon));
export {
  CaseUpper
};
//# sourceMappingURL=case-upper.js.map
